<template>
    <vx-modal v-model:visible="visible" size="sm" padding="standard">
        <template v-slot:header>Delete Migration</template>
        <template v-slot:subheader> Migration {{ migration.id }} </template>

        <div class="text-sm text-slate-800"><strong>Are you sure?</strong> There is no undo.</div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="confirm()"
                    data-test="confirm-delete"
                    :loading="deleting"
                    type="button"
                    class="grow"
                    size="lg"
                    color="danger"
                >
                    Delete
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import { ref } from 'vue';
import { HTTP_INTERNAL_SERVER_ERROR } from '~/support/HttpStatuses';
import { useToasted } from '~/composables/useToasted';
import { adminTeamMigrationsClient } from '~/services';

const toasted = useToasted();

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const props = defineProps({
    migration: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['deleted']);

const deleting = ref(false);

const confirm = async () => {
    if (deleting.value) {
        return;
    }

    try {
        deleting.value = true;

        await adminTeamMigrationsClient.deleteMigration(props.migration.id);

        emit('deleted', props.migration.id);
        visible.value = false;
    } catch (e) {
        console.error(e);
        if (e?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
            toasted.global.platform_error();
            return;
        }

        toasted.error(e.response?.data?.message || 'Something went wrong.');
    } finally {
        deleting.value = false;
    }
};
</script>
